import { useEffect } from 'react'

const Landing = () => {
    useEffect(() => {
        window.open(process.env.REACT_APP_URL_LANDING, '_self')
    }, [])

    return (null)
}
export default Landing